<div
  class="file-explorer"
  [class.file-explorer--dragging]="
    isDragging && (canDropToCurrentLevel || !!currentPath)
  ">
  <div
    *ngIf="isBusy"
    class="file-explorer__busy-overlay"
    aria-live="polite"
    aria-busy="true">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading…</span>
    </div>
  </div>
  <div class="file-explorer__toolbar">
    <div class="file-explorer__toolbar-left">
      <button
        class="file-explorer__nav-btn"
        [disabled]="!canGoBack"
        (click)="navigateBack()">
        <i class="bi bi-arrow-left"></i>
      </button>
      <button
        class="file-explorer__nav-btn"
        [disabled]="!canGoForward"
        (click)="navigateForward()">
        <i class="bi bi-arrow-right"></i>
      </button>
      <span class="file-explorer__toolbar-title">
        {{ currentPath ? currentFolderName : "Home" }}
      </span>
    </div>
    <span class="file-explorer__toolbar-hint"
      >Hold <kbd>Shift</kbd> to select multiple items</span
    >
    <div class="file-explorer__toolbar-actions">
      <ng-template #deleteConfirm>
        <ng-container *ngIf="selectedItems.length === 1">
          Are you sure you want to delete
          <strong>{{ getDisplayName(selectedItems[0].key) }}</strong
          >?
          <span *ngIf="selectedItems[0].isFolder">
            This will delete the folder and all its contents.
          </span>
        </ng-container>
        <ng-container *ngIf="selectedItems.length > 1">
          Are you sure you want to delete
          <strong>{{ selectedItems.length }} items</strong>?
          <span *ngIf="hasSelectedFolder">
            Folders and all their contents will be removed.
          </span>
        </ng-container>
        <div class="text-end mt-2">
          <button
            type="button"
            class="btn btn-secondary btn-sm px-3 m-1"
            (click)="trashPopover.close()">
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm px-3 m-1"
            (click)="deleteSelectedItems(trashPopover)">
            Delete
          </button>
        </div>
      </ng-template>
      <button
        class="file-explorer__action-btn"
        ngbTooltip="Upload Files"
        (click)="uploadModal.open()">
        <i class="bi bi-file-earmark-plus"></i>
      </button>
      <button
        class="file-explorer__action-btn"
        ngbTooltip="New Folder"
        (click)="createFolderModal.open()">
        <i class="bi bi-folder-plus"></i>
      </button>
      <button
        class="file-explorer__action-btn"
        [disabled]="
          !selectedDownloadableFiles.length || downloadState === 'loading'
        "
        [ngbTooltip]="
          selectedDownloadableFiles.length > 1
            ? 'Download ' + selectedDownloadableFiles.length + ' Files'
            : 'Download File'
        "
        (click)="downloadSelectedFiles()">
        <i
          class="bi"
          [class.bi-download]="downloadState === 'idle'"
          [class.bi-arrow-clockwise]="downloadState === 'loading'"
          [class.spin]="downloadState === 'loading'"
          [class.bi-check-lg]="downloadState === 'done'"
          [class.text-success]="downloadState === 'done'"></i>
      </button>
      <div class="file-explorer__action-separator"></div>
      <button
        class="file-explorer__action-btn file-explorer__action-btn--danger"
        [disabled]="!hasSelection"
        [ngbTooltip]="
          selectedItems.length > 1
            ? 'Delete ' + selectedItems.length + ' items'
            : selectedItems.length === 1
            ? 'Delete ' + (selectedItems[0].isFolder ? 'Folder' : 'File')
            : 'Delete'
        "
        [ngbPopover]="deleteConfirm"
        popoverTitle="Confirm Delete"
        [autoClose]="'outside'"
        #trashPopover="ngbPopover">
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </div>
  <div
    class="file-explorer__scroll"
    (dragover)="onExternalDragOver($event)"
    (dragleave)="onExternalDragLeave($event)"
    (drop)="onExternalDrop($event)">
    <div
      *ngIf="isExternalDragging"
      class="file-explorer__external-drop-overlay">
      <i class="bi bi-upload fs-2"></i>
      <span>Drop to upload</span>
    </div>
    <div class="file-explorer__table">
      <div class="file-explorer__header">
        <span class="file-explorer__col file-explorer__col--name">Name</span>
        <span class="file-explorer__col file-explorer__col--date"
          >Date Modified</span
        >
        <span class="file-explorer__col file-explorer__col--size">Size</span>
      </div>
      <div
        *ngFor="
          let item of visibleItems;
          let i = index;
          let odd = odd;
          trackBy: trackByKey
        "
        class="file-explorer__row"
        [class.file-explorer__row--odd]="odd && !isItemSelected(item.key)"
        [class.bg-primary]="isItemSelected(item.key)"
        [class.text-white]="isItemSelected(item.key)"
        [class.file-explorer__row--drag-over]="dragOverFolderKey === item.key"
        draggable="true"
        (dragstart)="onDragStart($event, item)"
        (dragover)="onDragOver($event, item)"
        (dragleave)="onDragLeave($event)"
        (dragend)="onDragEnd()"
        (drop)="onDrop($event, item)"
        (click)="onRowClick($event, item, i)">
        <span
          class="file-explorer__col file-explorer__col--name"
          [style.paddingLeft.px]="item.depth * 20">
          <button
            *ngIf="item.isFolder"
            class="file-explorer__chevron"
            (click)="$event.stopPropagation(); toggleFolder(item.key)">
            <i
              class="bi"
              [class.bi-chevron-right]="!expandedFolders.has(item.key)"
              [class.bi-chevron-down]="expandedFolders.has(item.key)"></i>
          </button>
          <span
            *ngIf="!item.isFolder"
            class="file-explorer__chevron-spacer"></span>
          <i
            class="bi me-2 file-explorer__icon"
            [class.file-explorer__icon--folder]="item.isFolder"
            [class.file-explorer__icon--file]="!item.isFolder"
            [ngClass]="getFileIcon(item.key)"></i>
          {{ getDisplayName(item.key) }}
        </span>
        <span class="file-explorer__col file-explorer__col--date">
          {{ formatDate(item.last_modified) }}
        </span>
        <span class="file-explorer__col file-explorer__col--size">
          {{ formatFileSize(item.size) }}
        </span>
      </div>
      <div
        *ngIf="!isBusy && visibleItems.length === 0"
        class="file-explorer__empty">
        No files found.
      </div>
      <div
        class="file-explorer__root-dropzone"
        [class.file-explorer__root-dropzone--active]="dragOverRoot"
        (dragover)="onDragOverRoot($event)"
        (dragleave)="onDragLeaveRoot($event)"
        (drop)="onDropToRoot($event)">
        <i class="bi bi-folder2-open me-2"></i>
        Move to
        {{
          canDropToCurrentLevel
            ? currentPath
              ? currentFolderName
              : "Home"
            : parentPath
            ? parentFolderName
            : "Home"
        }}
      </div>
    </div>
  </div>
  <div class="file-explorer__footer" *ngIf="knowledgeBase">
    <div class="file-explorer__footer-left">
      <span
        class="file-explorer__sync-pending mx-2"
        *ngIf="knowledgeBase.needs_sync === 1">
        Sync Pending
      </span>
      <button
        class="btn btn-sm btn-outline-primary"
        *ngIf="knowledgeBase.needs_sync === 1"
        (click)="forceSync()">
        Force Sync
      </button>
    </div>
    <span class="file-explorer__last-sync">
      Last Sync:
      {{
        knowledgeBase.last_sync
          ? (knowledgeBase.last_sync | formatDateTime)
          : "—"
      }}
    </span>
  </div>
</div>

<app-s3-file-upload-modal
  [currentPath]="currentPath"
  (refreshList)="onFilesChanged()">
</app-s3-file-upload-modal>

<app-s3-create-folder-modal
  [currentPath]="currentPath"
  (refreshList)="onFilesChanged()">
</app-s3-create-folder-modal>
